import { createContext, useContext } from 'react';

const ProductContext = createContext({});

export const ProductContextProvider = ({ components = {}, children }) => {
  return (
    <ProductContext.Provider value={components}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProductContext = () => useContext(ProductContext);


export default ProductContext;
